import { render } from "./nticket.vue?vue&type=template&id=bca40e74"
import script from "./nticket.vue?vue&type=script&lang=ts"
export * from "./nticket.vue?vue&type=script&lang=ts"

import "./nticket.vue?vue&type=style&index=0&id=bca40e74&lang=css"
script.render = render

export default script